import { List, Map, Record } from "immutable";

import { NARRATIVE_LABEL_AUTOMATIC } from "../../../../constants/narrativeAutomaticLabel";
import createFromJS from "../../../createFromJS";
import { DateRecord } from "./DateRecord";
import { TimespanRecord } from "./TimespanRecord";

export const ItemRecord = Record({
  id: null,
  type: null,
  displayId: null,
  label: null,
  summary: null,
  // Narrative info -- null for automatic, or set a value otherwise
  narrativeLabel: NARRATIVE_LABEL_AUTOMATIC,
  // Named Color ID, or swatch color (both acceptable)
  color: null,
  // Super items
  super: null,
  children: List(),
  // Entity specific details
  initials: null,
  shortLabel: null,
  // Timeline specific info
  ongoing: false,
  startDate: DateRecord(),
  duration: TimespanRecord(),
  preferredStartDate: DateRecord(),
  latestStartDate: null,
  durationToEarliestEnd: null,
  preferredDuration: TimespanRecord(),
  preferredPrecision: null,
  isDateLocked: false,
  // Anniversary Info
  showAnniversary: false,
  anniversaryIcon: "markerOther",
  // References/Relationships with other things
  references: List([]),
  inverseReferences: List([]),
  // Dependencies and Constraints
  blockingDependencies: List(),
  blockedByDependencies: List(),
  dateConstraints: List(),
  // Properties... map of propertyId, value
  propertyValues: Map(),
  // Attachments etc.
  image: null,
  attachments: List(),
  links: List(),
  tags: List(),

  // Used during importing to allow updating existing items
  internalId: null,

  // Location URI: Only to be filled in for items of a location type (category = location)
  locationUri: null
});

const data = {
  objects: {
    startDate: "DateRecord",
    latestStartDate: "DateRecord",
    duration: "TimespanRecord",
    durationToEarliestEnd: "TimespanRecord",
    preferredStartDate: "DateRecord",
    preferredDuration: "TimespanRecord",
    references: "List",
    inverseReferences: "List",
    propertyValues: "Map",
    attachments: "List",
    links: "List",
    children: "List"
  }
};
createFromJS.registerCallback("ItemRecord", createFromJS.createNestedCallback(ItemRecord, data));
